// extracted by mini-css-extract-plugin
export var ellipsesOverflow = "_g3-a";
export var fulfillmentFormRail = "_g3-9";
export var headerTitleRow = "_g3-c";
export var orderDetailsWrapper = "_g3-7";
export var orderLinkTrigger = "_g3-2";
export var paymentInformationGrid = "_g3-h";
export var paymentSummaryColumn = "_g3-i";
export var shipmentContainer = "_g3-b";
export var shipmentDetailsMainPane = "_g3-8";
export var shipmentNavigationCard = "_g3-5";
export var shipmentNavigationRail = "_g3-3";
export var shipmentNavigationRailHeader = "_g3-4";
export var shipmentSummaryFact = "_g3-e";
export var shipmentSummaryGrid = "_g3-d";
export var shipmentSummaryMetadataRow = "_g3-f";
export var shipmentSummaryTags = "_g3-g";
export var shipmentWorkspace = "_g3-0";
export var shipmentWorkspaceContent = "_g3-6";
export var shipmentWorkspaceHeader = "_g3-1";